module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-col', [_c('mu-card', {
    staticClass: "messageContainer",
    class: _vm.messageClass
  }, [_c('div', {
    staticClass: "titleWrap"
  }, [_c('img', {
    staticClass: "titleIcon",
    attrs: {
      "src": _vm.messageIcon
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "titleText"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "bodyWrap"
  }, [_c('span', {
    staticClass: "bodyText"
  }, [_vm._v(_vm._s(_vm.message))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f76d7dac","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FlashMessage/MessageBox.vue
// module id = 3318
// module chunks = 1